module.exports = "pegasus_template/assets/preview-7.png";